<template>
    <div>
        <el-table
                ref="multipleTable"
                :data="tableData"
                border
                fit
                tooltip-effect="dark"
                style="width: 100%">
            <el-table-column
                    type="index"
                    width="50">
            </el-table-column>
            <el-table-column
                    prop="scheme_name"
                    label="方案名称"
                    width="120">

            </el-table-column>
            <el-table-column
                    prop="contact_name"
                    label="客户"
                    width="120">
            </el-table-column>
<!--            <el-table-column-->
<!--                    prop="phone"-->
<!--                    label="电话"-->
<!--                    show-overflow-tooltip>-->
<!--            </el-table-column>-->
            <el-table-column
                    prop="project_address"
                    label="地址"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="discount_price_all"
                    label="总价"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="create_date"
                    label="时间"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column

                    label="操作"
                    show-overflow-tooltip>
<!--                slot-scope="scope"-->
                <template  slot-scope="scope">
<!--                    <el-button type="text" @click="programDetailAction">详情</el-button>-->
                    <a ref="target" href="" target="_blank" @click="pushSchemeList(scope.row.scheme_hash)" style="color: #333333;font-size:14px; ">详情</a>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
  name: "program_custom",
  props:[
    'tableData'
  ],
  data(){
    return {
//       tableData:[{'name':'两室两厅方案','team':'管理员', 'address':'fasdfasdfas','phone':'18917597980'},
//         {'name':'张三','team':'管理员', 'address':'fasdfasdfas','phone':'18917597980'},
// ],

    }
  },
  methods:{
    pushSchemeList(e){
      console.log('跳转到详情')
      var url = 'http://vip.stdq.com/scheme/#/index/programInfo/'+e+'/?'+'token='+this.getUserInfo.utoken+'&'+'company='+this.getUserInfo.usercompany+'&'+'scheme_hash='+e
      // var url = 'http://localhost:8085/#/index/programInfo/'+e+'/?'+'token='+this.getUserInfo.utoken+'&'+'company='+this.getUserInfo.usercompany

      window.open(url, '_blank');
    },
  },
  computed:{
    // TODO 上线要改
    getUserInfo(){
      return this.$store.getters.get_userInfo
    }
  },
}
</script>

<style scoped>

</style>
